// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f6c4b553","455":"19ed06f5","977":"03f7e654"}[chunkId] + ".chunk.js";
};